import {
  AuthProvider,
  LocaleProvider,
  PolicyProvider,
  ToastProvider,
} from '@retainerclub/hooks';
import { Outlet, ScrollRestoration } from 'react-router';
import { Toast } from '../shared';
import { LegalModal } from '../views/Legal';

function AppInner() {
  return (
    <>
      <ScrollRestoration />
      <AuthProvider>
        <LocaleProvider>
          <ToastProvider>
            <PolicyProvider>
              <Outlet />
              <Toast />
              <LegalModal />
            </PolicyProvider>
          </ToastProvider>
        </LocaleProvider>
      </AuthProvider>
    </>
  );
}

export default AppInner;
